(function ($) {

	class PushLogic_Refer_A_Friend {

		constructor() {
			this.form();
		}

		getEndpointUrl() {
			const host = window.location.host;
			const dev_endpoint = 'https://dev-shopify.treasuretrails.co.uk';
			const live_endpoint = 'https://shopify.treasuretrails.co.uk';

			if (host == 'treasure-trails-dev.myshopify.com') {
				return dev_endpoint;
			} else if (host == 'treasuretrails.co.uk') {
				return live_endpoint;
			} else {
				return live_endpoint;
			}
		}

		form() {
			var self = this,
				form = $('#pltt-refer-a-friend-activate');

			if (form.length > 0) {
				$(form).on('submit', function (e) {
					e.preventDefault();

					var customer_id = form.find('input[name="customer_id"]').val(),
						customer_email = form.find('input[name="customer_email"]').val(),
						data = {
							'customer_id': customer_id,
							'customer_email': customer_email
						};

					self.push_data(form, data);
				});
			}
		}

		set_success(element, text) {
			$('<span id="pltt-refer-a-friend-success">' + text + '</span>').appendTo($(element));
		}

		set_failure(element, text) {
			$('<span id="pltt-refer-a-friend-error">' + text + '</span>').appendTo($(element));
		}

		push_data(form, data) {
			var self = this,
				wrap = form.closest('#pltt-refer-a-friend-status'),
				webhook_endpoint = '/apps/hub/referral/activate';

			$.ajax({

				type: 'POST',
				url: webhook_endpoint,
				data: JSON.stringify(data),
				dataType: 'json',
				contentType: 'application/json',

				success: function (response) {
					if (response.success) {
						self.set_success(form, 'Refer a Friend activated. Your Code is ' + '<strong>RaF-' + data.customer_id + '</strong>');
						setTimeout(function () {
							$(form).fadeOut(function () {
								wrap.empty();
								$('<h2>Your Refer a Friend Code</h2><span id="pltt-refer-a-friend-code">RaF-' + data.customer_id + '</span>').appendTo(wrap);
							});
						}, 3000);
					}
				},

				error: function (jqXHR, exception) {
					var error = '';

					if (jqXHR.status === 0) {
						error = 'Can\'t connect.\n Verify Network.';
					} else if (jqXHR.status == 404) {
						error = 'Requested page not found (404).';
					} else if (jqXHR.status == 500) {
						error = 'Internal Server Error (500).';
					} else if (jqXHR.status == 401) {
						error = 'Request Unauthorized (401).';
					} else if (exception === 'parsererror') {
						error = 'Requested JSON parse failed.';
					} else if (exception === 'timeout') {
						error = 'Time out error.';
					} else if (exception === 'abort') {
						error = 'Ajax request aborted.';
					} else {
						error = 'Uncaught Error.\n' + jqXHR.responseText;
					}

					console.error(error);
					self.set_failure(form, 'Refer a Friend not activated. Error details: ' + error);
				},
			});
		}

	}

	new PushLogic_Refer_A_Friend;

})(jQuery);